import tw from "tailwind-styled-components"


export const DashboardContainer = tw.div `
lg:w-[84%]
ml-auto
mt-0   
lg:px-10 
px-6 
pb-4   
transition 
ease-in 
duration-300 
mb-20
md:mb-0

`